import { createSlice } from "@reduxjs/toolkit";

export const groupsSlice = createSlice({
  name: "groups",
  initialState: { groups: [], status: "idle", error: null },
  reducers: {
    setGroups: (state, action) => {
      if (!Array.isArray(action.payload)) return;
      state.groups = action.payload;
      state.status = "ready";
      state.error = null;
    },
    setGroupsStatus: (state, action) => {
      state.status = action.payload?.status || "idle";
      state.error = action.payload?.error ?? null;
    },
    clearGroups: (state) => {
      state.groups = [];
      state.status = "idle";
      state.error = null;
    },
  },
});

export const { setGroups, setGroupsStatus, clearGroups } = groupsSlice.actions;

export default groupsSlice.reducer;
